import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import ContentContainer from '~/client/components/content-container/content-container';
import Layout from '~/client/components/layout/layout';
import type { NotFoundPage as Props } from './not-found-page.types';

const NotFoundPage: React.FunctionComponent<Props> = ({ layout, title }) => (
  <Layout {...layout}>
    <div className="not-found-page">
      <ContentContainer>
        <div className="not-found-page__title">
          <Text
            elementName="h1"
            size={Text.sizes.headline2}
            theme={Text.themes.headline}
            italic
          >
            {title}
          </Text>
        </div>
      </ContentContainer>
    </div>
  </Layout>
);

export default NotFoundPage;
